import { SignUp } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { z } from "zod";
import { setIntendedPlan } from "@/lib/intended-plan";

const signUpSearchSchema = z.object({
  plan: z.string().optional(),
});

export const Route = createFileRoute("/sign-up/$")({
  validateSearch: signUpSearchSchema,
  component: SignUpPage,
});

function SignUpPage() {
  const { plan } = Route.useSearch();

  useEffect(() => {
    if (plan) setIntendedPlan(plan);
  }, [plan]);

  // fallbackRedirectUrl, not forceRedirectUrl: a new operator who signs up
  // mid-OAuth (Clerk acting as our OIDC provider) arrives with a ?redirect_url
  // back to its consent page. forceRedirectUrl would override that and strand
  // them on /onboarding, breaking the brokered CLI login. fallback lets Clerk's
  // redirect_url win when present, and still sends fresh sign-ups to onboarding.
  return (
    <div className="min-h-dvh grid place-items-center bg-background p-6">
      <SignUp
        routing="path"
        path="/sign-up"
        signInUrl="/sign-in"
        fallbackRedirectUrl="/onboarding"
      />
    </div>
  );
}
